import React, { useState } from "react";
import { useQuery } from "react-query";
import {
  getRunsByArea,
  updateRunInScheduleJobs,
} from "../../api/services/scheduling";
import { useSnackbar } from "notistack";
import CustomSelect from "../../components/FormFields/CustomSelect/CustomSelect";
import { Button, Box, Stack } from "@mui/material";
import CreateRunModal from "./CreateRunModal";
import { QK } from "../../base/qk";

const SelectRun = ({ area, visitId, setIsRunAdded }) => {
  const [run, setRun] = useState(null);
  const [showRunModal, setShowRunModal] = useState(false);
  const [hasRun, setHasRun] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const { data: runsByArea } = useQuery(
    [QK.runsByArea, area],
    () => getRunsByArea(area),
    {
      enabled: !!area,
      onSuccess: (data) => {
        if (data.length === 0) {
          enqueueSnackbar(
            "No runs have been created yet. Please create one first, e.g., Croydon1 or Croydon2",
            { variant: "warning" }
          );
        } else {
          setHasRun(true);
        }
      },
    }
  );

  const runOptions = runsByArea?.map((r) => ({
    value: r.id,
    label: r.display_name || r.name || `Run ${r.id}`
  })) || [];

  const handleRunChange = (e) => {
    setRun(e.target.value);
  };

  const handleRunSubmit = async () => {
    if (!run) {
      enqueueSnackbar("Please select a run", { variant: "error" });
      return;
    }
    const response = await updateRunInScheduleJobs(visitId, { run });
    if (response.status === 200) {
      enqueueSnackbar(response.data.message, { variant: "success" });
      setIsRunAdded(true);
    } else {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    }
  };

  return (
    <Box>
      {hasRun && (
        <Stack direction="row" spacing={2} alignItems="center">
          <CustomSelect
            label="Select Run"
            name="run"
            options={runOptions}
            value={run}
            onChange={handleRunChange}
            fullWidth
            placeholder="Select a run"
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleRunSubmit}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "8px",
              bgcolor: "#2469F0",
              px: 3,
              "&:hover": {
                bgcolor: "#1A5BD4",
                boxShadow: "0px 4px 12px rgba(36, 105, 240, 0.3)",
              },
            }}
          >
            Submit
          </Button>
        </Stack>
      )}

      <Button
        variant="outlined"
        color="primary"
        size="small"
        onClick={() => setShowRunModal(true)}
        sx={{
          textTransform: "none",
          fontWeight: 500,
          borderRadius: "8px",
          borderColor: "#D0D5DD",
          color: "#344054",
          mt: hasRun ? 2 : 0,
          "&:hover": {
            bgcolor: "#F9FAFB",
            borderColor: "#98A2B3",
          },
        }}
      >
        + Create New Run for Schedule
      </Button>

      <CreateRunModal
        show={showRunModal}
        area={area}
        handleClose={() => setShowRunModal(false)}
      />
    </Box>
  );
};

export default SelectRun;